//  for local

// APP_URL = 'http://localhost:8080/';
// API_URL = 'http://localhost:8000/';
// API_ADVERT_URL = 'http://localhost:8000/api/advert';
// API_USERS_URL = 'http://localhost:8000/api/';
// API_ADMIN_URL = 'http://localhost:8000/api/admin';
// TIMEZONE = 'Europe/London';

//  for development
/*
APP_URL = 'http://2link.websoptimization.com/';
API_URL = 'http://local.websoptimization.com:8081/';
API_ADVERT_URL = 'http://local.websoptimization.com:8081/api/advert';
API_USERS_URL = 'http://local.websoptimization.com:8081/api/';
API_ADMIN_URL = 'http://local.websoptimization.com:8081/api/admin';
TIMEZONE = 'Europe/London';
*/

//  for Production

APP_URL = 'https://admin.2linkapp.com/';
API_URL = 'https://api.2linkapp.com/';
API_ADVERT_URL = 'https://api.2linkapp.com/api/advert';
API_USERS_URL = 'https://api.2linkapp.com/api/';
API_ADMIN_URL = 'https://api.2linkapp.com/api/admin';
TIMEZONE = 'Europe/London';
